const INVITATION_QR_STYLES = {
  midnight: { label: 'Квадраты', dark: '#102a43', light: '#eef6ff', dotType: 'square', cornerType: 'square' },
  ocean: { label: 'Закруглённые', dark: '#087f8c', light: '#e6fffa', dotType: 'rounded', cornerType: 'extra-rounded' },
  forest: { label: 'Кружочки', dark: '#276749', light: '#f0fff4', dotType: 'dots', cornerType: 'dot' },
  violet: { label: 'Classy', dark: '#6b46c1', light: '#faf5ff', dotType: 'classy', cornerType: 'classy' },
  lavender: { label: 'Мягкий', dark: '#5b5fc7', light: '#f5f3ff', dotType: 'classy-rounded', cornerType: 'extra-rounded' },
  rose: { label: 'Розовый dots', dark: '#b83280', light: '#fff5f7', dotType: 'dots', cornerType: 'square' },
  berry: { label: 'Berry classy', dark: '#9b2c2c', light: '#fff5f5', dotType: 'classy', cornerType: 'dot' },
  sunset: { label: 'Коралловый', dark: '#c05621', light: '#fffaf0', dotType: 'rounded', cornerType: 'square' },
  coral: { label: 'Coral dots', dark: '#dd6b20', light: '#fffaf0', dotType: 'dots', cornerType: 'extra-rounded' },
  gold: { label: 'Gold classy', dark: '#975a16', light: '#fffff0', dotType: 'classy-rounded', cornerType: 'classy-rounded' },
  mint: { label: 'Мятный логотип', dark: '#047857', light: '#ecfdf5', dotType: 'rounded', cornerType: 'extra-rounded', logo: true },
  graphite: { label: 'Чёрный логотип', dark: '#1f2937', light: '#f3f4f6', dotType: 'dots', cornerType: 'dot', logo: true },
};

export const QR_PATTERNS = {
  square: { label: 'Квадраты', dotType: 'square', cornerType: 'square' },
  rounded: { label: 'Закруглённые', dotType: 'rounded', cornerType: 'extra-rounded' },
  dots: { label: 'Кружочки', dotType: 'dots', cornerType: 'dot' },
  classy: { label: 'Classy', dotType: 'classy', cornerType: 'classy' },
  'classy-rounded': { label: 'Мягкий', dotType: 'classy-rounded', cornerType: 'extra-rounded' },
  logo: { label: 'С картинкой', dotType: 'rounded', cornerType: 'extra-rounded', useImage: true },
};

export const QR_COLORS = {
  black: { label: 'Чёрный', dark: '#111111', light: '#ffffff' },
  powder: { label: 'Пудровый', dark: '#789aaa', light: '#f3f8fa' },
  blush: { label: 'Розовый', dark: '#bd8d98', light: '#fff7f8' },
  lavender: { label: 'Лавандовый', dark: '#938bb4', light: '#faf9ff' },
  mint: { label: 'Мятный', dark: '#82a99a', light: '#f4fbf7' },
  peach: { label: 'Персиковый', dark: '#c99b78', light: '#fffaf5' },
};

export default INVITATION_QR_STYLES;
